
const NOTIFICATION_CATALOG = {
  check_regression: {
    label: "Check regression",
    description:
      "Alerts you whenever a check in controls assigned to you starts failing.",
  },
  check_runs_monitor: {
    label: "Check runs monitor",
    description: "Summarises the outcome of scheduled compliance check runs.",
  },
  policy_ack_reminder: {
    label: "Policy acknowledgement reminder",
    description:
      "Reminds employees who still have policies awaiting their acceptance.",
  },
  training_reminder: {
    label: "Security training reminder",
    description:
      "Reminds employees who have not completed their assigned security training.",
  },
  policy_training: {
    label: "Policy and training reminder",
    description:
      "Reminds employees about outstanding policy acknowledgements and training.",
  },
  download_agent_reminder: {
    label: "Agent download reminder",
    description:
      "Reminds employees who have not yet installed the Regodit agent on their device.",
  },
  role_change: {
    label: "Role change alert",
    description:
      "Notifies the relevant manager when an employee's role changes.",
  },
  termination: {
    label: "Offboarding alert",
    description:
      "Notifies the relevant team when an employee is offboarded so access can be revoked.",
  },
};

/**
 * "check_runs_monitor" -> "Check runs monitor"
 */
function humanizeKey(key = "") {
  const spaced = String(key).replace(/_/g, " ").trim();
  if (!spaced) return "";
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
}

export function getNotificationMeta(templateKey) {
  return (
    NOTIFICATION_CATALOG[templateKey] || {
      label: humanizeKey(templateKey),
      description: "",
    }
  );
}

export default NOTIFICATION_CATALOG;
